// NO EDITAR A MANO
// const id = "footer.link_apps.url-android-pro";
const valor = `https://play.google.com/store/apps/details?id=aplicacionpago.tiempo&referrer=utm_source%3Dmeteoredcom`;

export default valor;
